import { DeliveryMode, PaymentMode } from '../../interfaces/paymentAndDelivery.interface';

export default class DeliveryModeClass {
  public code: string;
  public type: string;
  public description: string;
  public pickupType: string;
  public price: number;
  public dataAutomationId: string;
  public paymentModes: PaymentMode[];

  constructor(deliveryMode: DeliveryMode){
    this.code = deliveryMode.code;
    this.description = deliveryMode.description;
    this.price = deliveryMode.price;
    this.paymentModes = deliveryMode.paymentModes;
    this.dataAutomationId = this.getAutomationId();
  }

  private getAutomationId(): string {
    const typeLowerCase = this.code.toLowerCase();

    return `delivery-${typeLowerCase}-radiobutton`;
  }
}
